var map = {
	"./Amy Jackson.svg": 8983,
	"./Amy Jacksons.svg": 4118,
	"./BlastholeDrillmark.svg": 8929,
	"./Botlogo.png": 989,
	"./Bruce Wayne.png": 5720,
	"./Bruce Wayne.svg": 9744,
	"./Bruce Waynes.svg": 3587,
	"./Bulldozermark.svg": 1067,
	"./ChatScreen/Button.png": 3974,
	"./ChatScreen/ButtonDisabled.svg": 1986,
	"./ChatScreen/Vector.png": 4311,
	"./ChatScreen/pb-img.png": 8342,
	"./Crane.svg": 9952,
	"./CraneLiftmark.svg": 4144,
	"./Crane_lift.svg": 9236,
	"./Ellipse 332.svg": 1853,
	"./Ellipse 334.svg": 5859,
	"./Emp1.svg": 5786,
	"./Excavator.svg": 4388,
	"./Fed Chilton.svg": 6431,
	"./Fed Chiltons.svg": 590,
	"./FedChill.svg": 9832,
	"./Fedchillmark.svg": 8835,
	"./Frank Miller.png": 8960,
	"./Frank Miller.svg": 6254,
	"./Frank Millers.svg": 9105,
	"./GAI.svg": 3410,
	"./Group.png": 6354,
	"./Group.svg": 7490,
	"./Henry Cavil.svg": 3932,
	"./Henry Cavils.svg": 9751,
	"./Jack Fred.svg": 9627,
	"./Jack Freds.svg": 2594,
	"./JackFredmark.svg": 8660,
	"./Joe Chill.svg": 1575,
	"./Joe Chills.svg": 1654,
	"./Karen Chilton.svg": 4621,
	"./Karen Chiltons.svg": 7860,
	"./KarenChiltonmark.svg": 7782,
	"./Lana Gordon.png": 3550,
	"./Lana Gordon.svg": 2558,
	"./Lana Gordons.svg": 3473,
	"./Loadermark.svg": 2415,
	"./Login Background.jpg": 1494,
	"./Mask Group.svg": 5560,
	"./Miningtruckmark.svg": 2281,
	"./Missing Helmet1.png": 5199,
	"./Missing Safety Gloves.mp4": 1984,
	"./Missing Safety Gloves.png": 7363,
	"./Missing Safety Gloves1.mp4": 2519,
	"./Missing Safety Gloves1.png": 4258,
	"./Missing Safety Goggles.mp4": 880,
	"./Missing Safety Goggles.png": 6041,
	"./Missing Safety Goggles1.mp4": 951,
	"./Missing Safety Goggles1.png": 1460,
	"./Missing Safety Helmet.mp4": 7265,
	"./Missing Safety Helmet1.mp4": 1352,
	"./Missing Safety Shoes.mp4": 7292,
	"./Missing Safety Shoes.png": 4317,
	"./Missing Safety Shoes1.mp4": 6939,
	"./Missing Safety Shoes1.png": 8880,
	"./Missing Safety Vest.png": 2015,
	"./Missing Safety Vest1.mp4": 3323,
	"./Missing Safety Vest1.png": 2614,
	"./Missing gloves.jpg": 7553,
	"./Missing gloves.mp4": 9884,
	"./Missing goggles.jpg": 7831,
	"./Missing goggles.mp4": 9980,
	"./Missing helmet.mp4": 7725,
	"./Missing helmet.png": 6396,
	"./Missing safety shoes.jpeg": 5682,
	"./Missing safety vest.mov": 9947,
	"./Missing safety vest.mp4": 7628,
	"./Missing shoes.mp4": 1432,
	"./Pannloa Van.png": 7019,
	"./Pannloa Van.svg": 2639,
	"./Pannloa Vans.svg": 3502,
	"./PannloaVanmark.svg": 4976,
	"./Pannola Van.png": 3129,
	"./Pannola Van.svg": 6057,
	"./Pannola.svg": 1842,
	"./Peter Bishop.svg": 4084,
	"./Peter Bishops.svg": 7167,
	"./PeterBishopmark.svg": 1705,
	"./Robert Pearson.svg": 9137,
	"./Robin Grayson.svg": 9996,
	"./Robin Graysons.svg": 9047,
	"./Selina Kyle.svg": 2644,
	"./Selina Kyles.svg": 5327,
	"./Wesly Tim.svg": 8183,
	"./Wesly Tims.svg": 3302,
	"./WeslyTimmark.svg": 5378,
	"./alert_icon.svg": 7071,
	"./alert_veh.svg": 9646,
	"./all-good-logo.svg": 1536,
	"./arrow-right.png": 1305,
	"./asequipment.svg": 3551,
	"./b-dot.png": 2143,
	"./b-drill.svg": 5189,
	"./bot-icon.png": 5424,
	"./bottom-logo.svg": 2648,
	"./bt1.svg": 2376,
	"./bucket-wheel-excavatormark.svg": 3182,
	"./bucketwheelexcavator.svg": 3763,
	"./bulldozer.svg": 7152,
	"./cb-logo.svg": 3374,
	"./cl1.svg": 2153,
	"./close-to-machinery-img.png": 304,
	"./close-to-machinery.mp4": 7595,
	"./close.svg": 5871,
	"./crane2.svg": 4853,
	"./cranesm.svg": 8012,
	"./ct-logo.jpg": 1188,
	"./ct1.svg": 5281,
	"./dragline-excavatormark.svg": 9422,
	"./dragline.svg": 4957,
	"./emp-logo.svg": 223,
	"./emp1-cap.svg": 3077,
	"./emp2.svg": 2809,
	"./emp3.svg": 440,
	"./emp4.svg": 2839,
	"./emp5.svg": 5974,
	"./emp6.svg": 6261,
	"./enter1.svg": 4682,
	"./equipmaintenance.svg": 7764,
	"./equipstatus.svg": 3513,
	"./equipteam.svg": 9096,
	"./equipwhours.svg": 6859,
	"./excavatorsm.svg": 2712,
	"./fire-img.png": 8301,
	"./fire.mp4": 9846,
	"./fitness-logo.svg": 4693,
	"./fk-lift.svg": 7910,
	"./fl1.svg": 2348,
	"./floor-map-full.png": 4756,
	"./floor-map.png": 6780,
	"./forklift.svg": 5882,
	"./forklift1.svg": 8295,
	"./forklift2.svg": 5172,
	"./forkliftred.svg": 4127,
	"./forkliftsm.svg": 2522,
	"./helmet-missing-vdo.png": 7617,
	"./hr1.svg": 1468,
	"./human-to-machinery-img.png": 325,
	"./human-to-machinery.mp4": 7486,
	"./iconamoon_bookmark-bold.png": 5873,
	"./img-cap.svg": 197,
	"./inciuser.svg": 2613,
	"./inctimline.svg": 9489,
	"./info-cap.svg": 670,
	"./info-logo.png": 7559,
	"./info1.svg": 138,
	"./info2.svg": 2489,
	"./inforec.svg": 1353,
	"./inforeg.svg": 3189,
	"./lb1.svg": 9088,
	"./left-logo.svg": 3218,
	"./leftMenu/bookmark.png": 7166,
	"./leftMenu/bookmarkDisabled.svg": 6294,
	"./leftMenu/compass.png": 160,
	"./leftMenu/compassDisabled.svg": 2562,
	"./leftMenu/folder.png": 5014,
	"./leftMenu/folderDisabled.svg": 6942,
	"./leftMenu/users.png": 7248,
	"./leftMenu/usersDisabled.svg": 9222,
	"./lift2.svg": 8208,
	"./loader.svg": 2060,
	"./loader2.svg": 7222,
	"./loader_m.svg": 9276,
	"./loadersm.svg": 6752,
	"./location-cap.svg": 5207,
	"./location-logo.png": 1776,
	"./location1.svg": 57,
	"./locationlg.svg": 2987,
	"./logi-logo.svg": 1134,
	"./login-lock.svg": 7364,
	"./login-lock1.svg": 7773,
	"./login-logo.svg": 3324,
	"./login-msg.svg": 1260,
	"./logo-con.svg": 959,
	"./logo.jpg": 5826,
	"./logout.png": 2601,
	"./logout.svg": 7195,
	"./low-air-quality-img.png": 2168,
	"./low-air-quality.mp4": 841,
	"./m-app-logo-v2.svg": 8681,
	"./m-app-logo-v3.svg": 2664,
	"./m-app-logo.svg": 5880,
	"./mail-icon.svg": 3146,
	"./main-bg.jpg": 7934,
	"./maintanance.svg": 4878,
	"./message-2.svg": 3275,
	"./mining-logo.svg": 7227,
	"./miningtruck.svg": 7422,
	"./missing-goggles-img.png": 5109,
	"./missing-goggles.mp4": 607,
	"./missing-helmet-img.png": 9703,
	"./missing-helmet-vdo.png": 3955,
	"./missing-helmet.mp4": 8360,
	"./missing-safety-vest-img.png": 3187,
	"./missing-safety-vest.mp4": 1810,
	"./more_horiz.png": 6087,
	"./msg.png": 8240,
	"./msg1.svg": 41,
	"./msgg.png": 2173,
	"./msgg.svg": 9655,
	"./msgg1.svg": 3972,
	"./ninety-logo.svg": 9328,
	"./normal_veh.svg": 4804,
	"./ol1.svg": 3021,
	"./orange_point.svg": 4160,
	"./pb1.svg": 7396,
	"./person-collapse-img.png": 9676,
	"./person-collapse.mp4": 6529,
	"./person-to-person-fight-img.png": 8991,
	"./person-to-person-fight.mp4": 2512,
	"./poisonous-gas-img.png": 5514,
	"./poisonous-gas.mp4": 9715,
	"./pt-logo.svg": 8095,
	"./pt_bishop.svg": 5375,
	"./qsm-logo-con.svg": 9249,
	"./qsm-logo.svg": 8814,
	"./red-point.svg": 9095,
	"./red_point.svg": 7697,
	"./rt-logo.svg": 1681,
	"./scissorsm.svg": 7049,
	"./sd-logo.svg": 6488,
	"./sdimg-10.svg": 4781,
	"./sdimg-2.svg": 7340,
	"./sdimg-3.svg": 5885,
	"./sdimg-4.svg": 1954,
	"./sdimg-5.svg": 5267,
	"./sdimg-6.svg": 5872,
	"./sdimg-7.svg": 6993,
	"./sdimg-8.svg": 3222,
	"./sdimg-9.svg": 6439,
	"./sh1.svg": 7501,
	"./shift1.svg": 7692,
	"./sm-cp-img.png": 1161,
	"./sm1.svg": 6074,
	"./sm2.svg": 2073,
	"./smart-mining-logo.svg": 387,
	"./sort.png": 8407,
	"./st1.svg": 5297,
	"./team1.svg": 8631,
	"./teams-cap.svg": 7730,
	"./time.svg": 4746,
	"./todo.svg": 7293,
	"./trips.png": 2835,
	"./trustbd.svg": 3919,
	"./unauthorized-entry-img.png": 5479,
	"./unauthorized-entry.mp4": 4567,
	"./user.svg": 3084,
	"./vehicle-to-vehicle-img.png": 428,
	"./vehicle-to-vehicle.mp4": 287,
	"./video-cap.svg": 209,
	"./wekr1.png": 1755,
	"./work-progress.svg": 418,
	"./worker1.svg": 2244,
	"./worker2.svg": 9015,
	"./worker8.png": 4021,
	"./worker_path.svg": 183,
	"./workstatus.svg": 5412,
	"./wrkr15.svg": 3087,
	"./wrp1.svg": 5835,
	"./ws1.svg": 6096,
	"./wss1.svg": 3983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;